var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.appLoading)?_c('Loader'):_c('div',[_c('Header'),_c('main',{staticClass:"container"},[_c('router-view')],1),(_vm.changePasswordDialog)?_c('PasswordModal',{attrs:{"request":_vm.changePassword,"necessarily":""},on:{"close":function($event){!_vm.changePasswordDialog}}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }